import type { Decision } from '../shared/types';

export const selectionLimit = (decision: Decision | null): number => decision === 'accept' ? 1 : 2;
export const canConfirmSetback = (decision: Decision | null, count: number): boolean =>
  decision === 'accept' ? count >= 0 && count <= 1 : decision === 'reject' && count === 2;

/** A fresh set keeps cancellation possible even when the limit has been reached. */
export function toggleSetbackCard(selected: Set<string>, id: string, decision: Decision | null): Set<string> {
  const next = new Set(selected);
  if (next.has(id)) next.delete(id);
  else if (next.size < selectionLimit(decision)) next.add(id);
  return next;
}
